import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke072aRequest, Sgke072aResponse, Sgke072aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke072aService {

  /**
   * コンストラクタ
   * @param {Sgke072aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke072aService
   */
  constructor(
    private service: Sgke072aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 充当登録充当確定・充当解除API呼び出し
   * @param {Sgke072aRequest} request
   * @return {*}  {Observable<Sgke072aResponse>}
   * @memberof UsedSgke072aService
   */
  public doSgke072a(request: Sgke072aRequest): Observable<Sgke072aResponse> {

    return this.service.ke10WSGKE072APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE072A');
          return throwError(err.message);
        })
      );
  }
}
